import { render, staticRenderFns } from "./ItinerariesStopsTags.vue?vue&type=template&id=47b244f8&scoped=true"
import script from "./ItinerariesStopsTags.vue?vue&type=script&lang=js"
export * from "./ItinerariesStopsTags.vue?vue&type=script&lang=js"
import style0 from "./ItinerariesStopsTags.vue?vue&type=style&index=0&id=47b244f8&prod&scoped=true&lang=less"
import style1 from "./ItinerariesStopsTags.vue?vue&type=style&index=1&id=47b244f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b244f8",
  null
  
)

export default component.exports